/*
* @requires  ../util/websocket.js
*/

var HebcaMiddleware = HebcaMiddleware || {};
(function($m) {

    function FileSealWebsocket(param,m,callback) {
        this.host="ws://127.0.0.1:18213";
        this.context=param.context;
        this.websocket=$m.createWebSocketWrapper(param,this.host);
        this.setEventCallback(m,callback)
        this.websocket.connect(param);
    }

    FileSealWebsocket.prototype.setEventCallback=function(m,callback){
        this.middlewareObj=m;
        this.websocket.setEventCallback(m,callback);
    };

    FileSealWebsocket.prototype.signOfd=function(param){
        var name="signOfd";
        var that=this;
        var p={
            context: this.context,
        };
        $m.util.setAttrs(p,param,["context","command","multiSeal", "password", "inFile", "outFile", "inUrl", "outUrl",
            "partName", "fileName", "certVerify" , "sealVerify","enableTimeStamp"]);

        this.websocket.sendMessage({
            fun: 'SignOfd',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, null);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    FileSealWebsocket.prototype.hashOfd=function(param){
        var name="hashOfd";
        var that=this;
        var p={
            context: this.context,
        };
        $m.util.setAttrs(p,param,["command","inFile","inUrl", "certVerify", "sealVerify","enableTimeStamp"]);

        this.websocket.sendMessage({
            fun: 'HashOfd',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, json.data);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    FileSealWebsocket.prototype.hashOfdNext=function(param){
        var name="hashOfdNext";
        var that=this;
        var p={
            context: this.context,
        };
        $m.util.setAttrs(p,param,["command","inFile","inUrl","signature","dataHash", "certVerify", "sealVerify","enableTimeStamp"]);

        this.websocket.sendMessage({
            fun: 'HashOfdNext',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, json.data);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    FileSealWebsocket.prototype.mergeOfd=function(param){
        var name="mergeOfd";
        var that=this;
        var p={
            context: this.context,
        };
        $m.util.setAttrs(p,param,["signature","dataHash","outFile","outUrl","partName","fileName","certVerify","enableTimeStamp"]);

        this.websocket.sendMessage({
            fun: 'MergeOfd',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, null);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    FileSealWebsocket.prototype.verifyOfd=function(param){
        var name="verifyOfd";
        var that=this;
        var p={
            context: this.context,
        };
        $m.util.setAttrs(p,param,["inFile","inUrl","certVerify","sealVerify","detail"]);

        this.websocket.sendMessage({
            fun: 'VerifyOfd',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, json.result);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    FileSealWebsocket.prototype.signPdf=function(param){
        var name="signPdf";
        var that=this;
        var p={
            context: this.context,
        };
        $m.util.setAttrs(p,param,["context","command","multiSeal", "password", "inFile", "outFile", "inUrl", "outUrl",
            "partName", "fileName", "certVerify" , "sealVerify","enableTimeStamp","extSealConfig"]);

        this.websocket.sendMessage({
            fun: 'SignPdf',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, null);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    FileSealWebsocket.prototype.hashPdf=function(param){
        var name="hashPdf";
        var that=this;
        var p={
            context: this.context,
        };
        $m.util.setAttrs(p,param,["command","inFile","inUrl", "certVerify", "sealVerify","enableTimeStamp"]);

        this.websocket.sendMessage({
            fun: 'HashPdf',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, json.data);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    FileSealWebsocket.prototype.hashPdfNext=function(param){
        var name="hashPdfNext";
        var that=this;
        var p={
            context: this.context,
        };
        $m.util.setAttrs(p,param,["command","inFile","inUrl","signature","dataHash", "certVerify", "sealVerify","enableTimeStamp"]);

        this.websocket.sendMessage({
            fun: 'HashPdfNext',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, json.data);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    FileSealWebsocket.prototype.mergePdf=function(param){
        var name="mergePdf";
        var that=this;
        var p={
            context: this.context,
        };
        $m.util.setAttrs(p,param,["signature","dataHash","outFile","outUrl","partName","fileName","certVerify","enableTimeStamp"]);

        this.websocket.sendMessage({
            fun: 'MergePdf',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, null);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    FileSealWebsocket.prototype.verifyPdf=function(param){
        var name="verifyPdf";
        var that=this;
        var p={
            context: this.context,
        };
        $m.util.setAttrs(p,param,["inFile","inUrl","certVerify","sealVerify","detail"]);

        this.websocket.sendMessage({
            fun: 'VerifyPdf',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, json.result);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    FileSealWebsocket.prototype.pdf2ofd=function(param){
        var name="pdf2ofd";
        var that=this;
        var p={
            context: this.context,
        };
        $m.util.setAttrs(p,param,["inFile","inUrl","outFile","outUrl", "partName", "fileName"]);

        this.websocket.sendMessage({
            fun: 'Pdf2ofd',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, null);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    FileSealWebsocket.prototype.ofd2pdf=function(param){
        var name="ofd2pdf";
        var that=this;
        var p={
            context: this.context,
        };
        $m.util.setAttrs(p,param,["inFile","inUrl","outFile","outUrl", "partName", "fileName"]);

        this.websocket.sendMessage({
            fun: 'Ofd2pdf',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, null);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    FileSealWebsocket.prototype.openOfd=function(param){
        var name="openOfd";
        var that=this;
        var p={
            context: this.context,
        };
        $m.util.setAttrs(p,param,["fileName","renderThreadCount","maxCachePageCount","preRenderCount"]);

        this.websocket.sendMessage({
            fun: 'OpenOfd',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, json.data);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    FileSealWebsocket.prototype.closeOfd=function(param){
        var name="closeOfd";
        var that=this;
        var p={
            context: this.context,
        };
        $m.util.setAttrs(p,param,["fileId"]);

        this.websocket.sendMessage({
            fun: 'CloseOfd',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, null);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    FileSealWebsocket.prototype.getOfdInfo=function(param){
        var name="getOfdInfo";
        var that=this;
        var p={
            context: this.context,
        };
        $m.util.setAttrs(p,param,["fileId"]);

        this.websocket.sendMessage({
            fun: 'GetOfdInfo',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, json.data);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    FileSealWebsocket.prototype.saveOfd=function(param){
        var name="saveOfd";
        var that=this;
        var p={
            context: this.context,
        };
        $m.util.setAttrs(p,param,["fileId","fileName"]);

        this.websocket.sendMessage({
            fun: 'SaveOfd',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, null);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    FileSealWebsocket.prototype.ofdRenderPage=function(param){
        var name="ofdRenderPage";
        var that=this;
        var p={
            context: this.context,
        };
        $m.util.setAttrs(p,param,["fileId","pageIndex","ppm"]);

        this.websocket.sendMessage({
            fun: 'OfdRenderPage',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, json.data);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    FileSealWebsocket.prototype.getOfdPageInfo=function(param){
        var name="getOfdPageInfo";
        var that=this;
        var p={
            context: this.context,
        };
        $m.util.setAttrs(p,param,["fileId","pageIndex"]);

        this.websocket.sendMessage({
            fun: 'GetOfdPageInfo',
            param: JSON.stringify(p),
            success: function (json) {
                that.websocket.onSuccess(name, param, json.data);
            },
            fail: function (e) {
                that.websocket.onFail(name, param, e);
            }
        });
    };

    FileSealWebsocket.prototype.close=function(){
        this.websocket.close()
    };

    $m.FileSealWebsocket=FileSealWebsocket;

})(HebcaMiddleware);
